//region 1. Platform Libraries
import { assert } from 'chai';
//endregion

//region 2. Project Libraries
import {
    isValidPublicIP,
    isValidStreamIndex,
    stripUndefined,
    valueOf,
} from './Utils';
//endregion

//region T. Tests
describe('Utils', () => {
    describe('isValidPublicIP', () => {
        it('should return Error if no argument',
            () => assert.deepEqual(
                isValidPublicIP(),
                new Error('No Public IP'),
            ),
        );
        it('should return Error if malformed public IP',
            () => assert.deepEqual(
                isValidPublicIP('www.example.com'),
                new Error('Malformed Public IP www.example.com'),
            ),
        );
        it('should return Error if out of range',
            () => assert.deepEqual(
                isValidPublicIP('192.168.1.1'),
                new Error('Public IP in Invalid Range 192.168.1.1'),
            ),
        );
        it('should return true',
            () => assert.equal(
                isValidPublicIP('8.8.8.8'),
                true,
            ),
        );
    });

    describe('isValidStreamIndex', () => {
        it('should pass if 0', () => assert.equal(true, isValidStreamIndex(0)));
    });

    describe('stripUndefined', () => {
        const source = {
            field1: 'field1',
            field2: undefined,
        };
        it('should strip undefined', () => assert.deepEqual(
            stripUndefined(source),
            { field1: 'field1' },
        ));
    });

    describe('valueOf', () => {
        const source = {
            one: 'one',
            two: {
                one: 'two_one',
            },
            3: {
                one: '3_one',
            },
            four: [
                {},
                {
                    one: 'four_1_one',
                },
            ],
        };
        it('should get value', () => assert.equal(valueOf(source, 'one'), 'one'));
        it('should get value', () => assert.equal(valueOf(source, 'two', 'one'), 'two_one'));
        it('should get value', () => assert.equal(valueOf(source, 3, 'one'), '3_one'));
        it('should get value', () => assert.equal(valueOf(source, 'four', 1, 'one'), 'four_1_one'));
        it('should not get value', () => assert.equal(valueOf(), undefined));
        it('should not get value', () => assert.equal(valueOf(source, 3, 'two'), undefined));
    });
});
//endregion
